export default __webpack_public_path__ + "static/media/lock.e7c56c63.svg";